import React from 'react'
import styled from 'styled-components'
import { Spin } from 'antd'
import { useContentLoadingSelector } from '../redux/selectors/content'

interface WizrLoaderProps {
  loading?: boolean
  size?: 'small' | 'default' | 'large'
  text?: string
  fullPage?: boolean
  overlay?: boolean
  data?: any
  useDataAwareLoading?: boolean
}

const LoaderContainer = styled.div<{ fullPage: boolean; overlay: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;

  ${({ fullPage, overlay }) => {
    const getOverlayStyle = (shouldShow: boolean) =>
      shouldShow ? 'background-color: rgba(255, 255, 255, 0.8);' : ''

    return fullPage
      ? `
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        z-index: 9999;
        ${getOverlayStyle(overlay)}
      `
      : `
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: rgba(255, 255, 255, 1);
        z-index: 999;
      `
  }}
`

const LoaderText = styled.div`
  color: #666;
  font-size: 14px;
  margin-top: 8px;
`

const WizrLoader: React.FC<WizrLoaderProps> = ({
  loading = true,
  size = 'default',
  text,
  fullPage = false,
  overlay = true,
  data,
  useDataAwareLoading = false,
}) => {
  const isContentLoading = useContentLoadingSelector()

  let shouldShowLoader = loading

  if (useDataAwareLoading) {
    shouldShowLoader = isContentLoading || !data
  }

  if (!shouldShowLoader) return null

  return (
    <LoaderContainer fullPage={fullPage} overlay={overlay}>
      <Spin size={size} />
      {text && <LoaderText>{text}</LoaderText>}
    </LoaderContainer>
  )
}

export default WizrLoader
